import DocumentVerificationPositiveStepperControls from './DocumentVerificationPositiveStepperControls';

export default DocumentVerificationPositiveStepperControls;
